import React from 'react';
import { AwardIcon, ClipboardCheckIcon, FileTextIcon, FootprintsIcon, LibraryIcon, TargetIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { includedItems } from '../data/content';
const icons = {
  library: LibraryIcon,
  file: FileTextIcon,
  footprints: FootprintsIcon,
  clipboard: ClipboardCheckIcon,
  target: TargetIcon,
  award: AwardIcon
};
export function WhatsIncluded() {
  return <section className="w-full bg-white px-5 py-20 sm:px-8" data-id="element-240" data-mp="pwpcrn91rtz2">
      <div className="mx-auto w-full max-w-5xl" data-id="element-241" data-mp="uv0ns1b2waiv">
        <Reveal data-id="element-242" data-mp="utpks3pgj6st">
          <h2 className="mx-auto max-w-2xl text-center text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-243" data-mp="us4pgbvbjjtw">
            Vad ingår i Innebandy Ready-paketet?
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-244" data-mp="31kyhltmulfo2">
          {includedItems.map((item, index) => {
          const Icon = icons[item.icon as keyof typeof icons];
          return <Reveal as="li" key={item.title} delay={index % 3 * 0.06} data-id="element-245" data-mp="1whfc5o5txybd" data-mpi={index}>
                <div className="flex h-full flex-col rounded-2xl border border-sand bg-cream p-6" data-id="element-246" data-mp="1wjicp24lz9uc">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-level-blue/10" data-id="element-247" data-mp="1rkyosw6gfnzc">
                    <Icon className="h-5 w-5 text-level-blue" aria-hidden="true" data-id="element-248" data-mp="21grym7ssh3df" />
                  </span>
                  <h3 className="mt-5 text-base font-extrabold leading-snug text-navy" data-id="element-249" data-mp="2fg9t93srnaup">
                    {item.title}
                  </h3>
                  <p className="mt-auto pt-2 text-sm leading-relaxed text-muted" data-id="element-250" data-mp="2agouatdlj2hz">
                    {item.description}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}